<script>
  import { createEventDispatcher } from "svelte"

  const dispatch = createEventDispatcher()
  export let templateType = "Email"
</script>

<div class="fixed inset-0 z-10 flex items-center justify-center overflow-hidden bg-[#000000cc] backdrop-blur-md">
  <div class="relative m-6 w-[700px] transform select-none rounded-md bg-white text-left transition-all dark:bg-bodyblack md:m-0">
    <div class="flex w-full items-center justify-center rounded-md bg-white p-2 text-black dark:bg-bodyblack sm:p-6">
      <h1 class="text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Leave {templateType} template</h1>
    </div>

    <div class="flex items-center justify-center px-3 py-3 text-center text-gray-400 mobile:p-6 mobile:py-0 mobile:px-6 sm:text-justify">There are unsaved modifications. Would you like to save them and leave?</div>

    <div class="flex flex-row items-center justify-center gap-3 rounded-md bg-white p-2 dark:bg-bodyblack sm:p-6 md:gap-0">
      <button
        type="button"
        on:click={() => {
          dispatch("cancel")
        }}
        class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-blue-500 hover:text-white focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-blue-500 sm:ml-3 sm:w-auto"
      >
        <span>
          <i class="fa-solid fa-circle-xmark" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Cancel</span>
      </button>
      <button
        type="button"
        on:click={() => {
          dispatch("dontSave")
        }}
        class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-red-500 hover:text-white focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-red-500 sm:ml-3 sm:w-auto"
      >
        <span>
          <i class="fa-solid fa-ban" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Don't Save</span>
      </button>

      <button type="button" on:click class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-green-500 hover:text-white focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-green-500 sm:ml-3 sm:w-auto">
        <span>
          <i class="fa-solid fa-circle-check" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Save</span>
      </button>
    </div>
  </div>
</div>
